import { VendorUpdateUseCase } from '../../../../application';

export default class VendorUpdateService {

    async execute(event) {
        const data = await VendorUpdateUseCase(event);
        return data;
    }
}
